export default __webpack_public_path__ + "9efce3a3d53a0f46c7b64464cc397252.png";